import * as z from "zod/v4";

export const createSupportAiSubscription = {
  name: "createSupportAiSubscription" as const,
  input: z.object({}).optional(),
  output: z.object({
    success: z.boolean(),
    confirmationUrl: z.string().optional(),
  }),
};
